<app-onboarding-profile-shell [showFooter]="showFooter()">
  <div shellEyebrow
    class="tw-mb-2 tw-flex tw-w-fit tw-items-center tw-gap-1">
    <p class="tw-text-300 tw-font-normal tw-uppercase tw-leading-1.2 tw-text-gray-800"
      i18n="@@youAreVerified">You are verified</p>
    <cs-icon class="tw-h-3.25 tw-w-3.25 tw-text-teal-600"
      [iconName]="'green_tick_circle'"></cs-icon>
  </div>
  <div shellHeading
    class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
    [class.tw-text-600]="isDravidianScriptUser()"
    [class.tw-text-700]="!isDravidianScriptUser()"
    i18n="@@selectYourGender">Select <br/> your gender</div>

  <div class="tw-flex tw-items-stretch tw-gap-2 tw-pt-3"
    id="genderSelection">
    <app-onboarding-gender-card [gender]="appConfig.Shared.Gender.FEMALE"
      [selected]="isFemaleSelected()"
      (genderSelected)="selectGender($event)">
      <p i18n="@@iAmFemale">I am <b class="tw-font-bold before:tw-whitespace-pre before:tw-content-line-break">Female</b></p>
    </app-onboarding-gender-card>
    <app-onboarding-gender-card [gender]="appConfig.Shared.Gender.MALE"
      [selected]="isMaleSelected()"
      (genderSelected)="selectGender($event)">
      <p i18n="@@iAmMale">I am <b class="tw-font-bold before:tw-whitespace-pre before:tw-content-line-break">Male</b></p>
    </app-onboarding-gender-card>
  </div>
  @if (showGenderError()) {
    <app-onboarding-profile-field-error id="genderError">
      <span i18n="@@enterGender"> Select your gender </span>
    </app-onboarding-profile-field-error>
  }

  <button shellFooter
    csButton
    id="continueBtn"
    type="button"
    class="tw-w-full"
    [loading]="loading()"
    (click)="handleContinue()"><span i18n="@@continueNew">Continue</span>
  </button>
</app-onboarding-profile-shell>
